export default __webpack_public_path__ + "static/media/naslovna2.403ea0f3.jpeg";